import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import * as $ from 'jquery';
import { HttpClient } from '@angular/common/http';
import { UserSettings } from './usersettings';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
var moment = require('moment');
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { CommonFunction } from '../main/CommonFunction';
import { Subscription } from 'rxjs';
import { CommonReportService } from '../shared/services/CommonReportService.service';
import { CustomDateFormat } from './CustomDateFormat';
import { DatePipe } from '@angular/common';
import { CsvExportParams, GridApi } from 'ag-grid-community';
@Component({
    selector: 'ledger-template',
    template: require('./commonLedgerTemplate.html'),
    styles: [``]
})
export class commonLedgerTemplateComponent implements OnInit {
    @Input('customername') Customer_Name: any;
    @Input('customerid') Customer_ID: any;
    @Input("dValue") dvalue: any;
    @Input("customercode") Customer_Code: any;
    @Input("customercreditdays") CreditDays: any;
    @Input("customercreditlimit") CreditLimit: any;
    @Input("customertradedisc") TradeDiscount: any;
    @Input("customeravgGP") Sales_Margin: any;
    @ViewChild('payreciptpopup') payreciptpopup: ElementRef;
    @ViewChild('OptionModal') OptionModal: ElementRef;
    @ViewChild('PrintOptionModal') PrintOptionModal: ElementRef;
    @ViewChild('accountpostingpopup') accountpostingpopup: ElementRef;

    static parameters = [UtilityService, HttpClient, NgbModal, HotkeysService, BsDatepickerConfig, CommonFunction, CommonReportService, CustomDateFormat, DatePipe]
    dateFormat: any;
    bsConfig: any;
    busy: Subscription;
    public overlayNoRowsTemplate: any;
    toastWarningMsg(msg) {
        this.toast({ type: 'warning', title: msg });
    }
    constructor(public utilityService: UtilityService, public http: HttpClient, private modalService: NgbModal, private hotkeysService: HotkeysService, public _bsDatepickerConfig: BsDatepickerConfig, public commonFunction: CommonFunction, public commonReportService: CommonReportService, public customDateFormat: CustomDateFormat, public datePipe: DatePipe) {
        this.http = http;
        this.modalService = modalService;
        this.hotkeysService = hotkeysService;
        this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        this.dateFormat = JSON.parse(localStorage.getItem('permission'))[0];
        this.bsConfig = Object.assign({}, { dateInputFormat: this.unitInfo.dateInputFormat, containerClass: this.unitInfo.dateColorTheme });
        this._bsDatepickerConfig.dateInputFormat = this.unitInfo.dateInputFormat;

        $(document).ready(function () {
            var header = $('ledger-template .modal-header').height();
            var footer = $('ledger-template .modal-body .row.footer').height();
            var body = $('ledger-template').parent().height();
            var appHeight = body - header - footer + 'px !important';
            $('ledger-template .modal-body .table-responsive.ledger').attr('style', 'height:' + appHeight);
        })
    }

    gridApiPrd: any;
    gridColumnApiPrd: any;
    selectedProductInfo: any;
    prodList: any;
    paginationConf: any;
    d: any;
    productListDef: any;
    defaultColDef: any;
    rowSelectionSingle: string;
    searchValue: any;
    unitInfo: any;
    ProductStock: any;
    TblProductStock: any;
    modalReference: NgbModalRef;
    optionmodalReference: NgbModalRef;
    PrintOptionModalReference: NgbModalRef;
    public orderSearch2: any;
    public overlayLoadingTemplate: any;
    public Config_Leger_From_Date: any;
    public rowClassRules: any;
    public rowClassRules1: any;
    //filterType:any;
    SortedProdList: any;
    public hotkeyList: Hotkey[];
    type: any;
    toast = Swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        // backdrop: `rgba(30, 30, 37, 0.4)`
    });
    With_ShipTo: any = 0;
    userUnitList: any;

    ngOnInit(): void {
        this.rowSelectionSingle = "single";
        this.d = this.dvalue;
        this.overlayNoRowsTemplate = "<h4> No record to show. </h4>";
        this.paginationConf = UserSettings.enablePagination;

        this.defaultColDef = {
            resizable: true
        };

        if ("SystemConfigDetails" in localStorage) {
            var data = JSON.parse(localStorage.getItem('SystemConfigDetails'));
            var ConfigDate = data.filter(function (item) {
                return item.Config_Name === 'Customer Ledger From Date'
            });
            //var currentdate = moment(new Date()).format('YYYY');
            this.Config_Leger_From_Date = (ConfigDate ? ConfigDate[0].Config_Value : '');
            if (this.Config_Leger_From_Date) {
                this.Config_Leger_From_Date = (this.unitInfo.CurrentFYear + "-" + this.Config_Leger_From_Date);
                this.Config_Leger_From_Date = moment(this.Config_Leger_From_Date).format(this.dateFormat.dateInputFormat);
            } else {
                this.Config_Leger_From_Date = this.oneMonthAgo();
            }
        }

        this.initHotkeys();
        this.initModalQuery('.page-search');
        setTimeout(() => {
            $("#From_Date").focus();
        }, 200);
        this.ledgerSearch.From_Date = this.Config_Leger_From_Date;
        this.ledgerSearch.To_Date = new Date();
        // this.customerLedgermain();
        // this.custLedgerRowData = [];
        this.lastSearchObject = {};
        this.overlayLoadingTemplate = "<div class='loader2'>" +
            "<div class='loading'><img src='public/loader-icon-2.svg'></div>" +
            "</div>";
        this.getUserUnitList().then((unitList) => {
            this.userUnitList = unitList;
        })
    }

    ngAfterViewInit() {
        this.paginationConf = UserSettings.enablePagination;
    }

    initHotkeys() {
        this.hotkeyList = [];

        let ctrlo = new Hotkey('alt+o', (event: KeyboardEvent): boolean => {
            $('ledger-template #okbtn1').trigger('click');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrlo);
        this.hotkeysService.add(ctrlo);

        let ctrle = new Hotkey('alt+e', (event: KeyboardEvent): boolean => {
            $('ledger-template #excelbtn').trigger('click');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrle);
        this.hotkeysService.add(ctrle);

        const ctrlf = new Hotkey('ctrl+f', (event: KeyboardEvent): boolean => {
            $("ledger-template #cust-ledger-filter-text-box").focus();
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrlf);
        this.hotkeysService.add(ctrlf);

        let alta = new Hotkey('alt+a', (event: KeyboardEvent): boolean => {
            $('ledger-template #payment-details').trigger('click');
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(alta);
        this.hotkeysService.add(alta);
    }

    initModalQuery(className) {
        var parent = this;
        // let jqueryclass = className + ' ul.form-group';
        $(className).on('keydown', 'input, select, textarea, input[role=combobox]', function (e) {
            var self = $(this)
                , form = self.parents(className + ':eq(0)')
                , focusable
                , next
                ;
            if (e.keyCode == 13) {
                // focusable = form.find('input:not([type="radio"]), input:enabled, a, select, button, textarea, input[role=combobox]').filter(':visible');
                focusable = form.find('input:not([type="radio"]), input[role=combobox]').filter(':visible');
                next = focusable.eq(focusable.index(this) + 1);

                if (this.classList.contains('custom-date')) {
                    parent.customDateFormat.GetCustomDateFormat(this, parent.datePipe);
                }
                if (next.length) {
                    next.focus().select();
                } else {
                    $('#okbtn1').focus();
                    // $(id).focus();
                    //form.submit();
                    //parent.addCompany();
                }
                return false;
            }
        });
    }

    f_chkString(p_value) {
        var Val = (p_value ? p_value.toString() : "").trim();
        return Val;
    }

    f_chkNum(p_value) {
        var Val = Number(p_value);
        if (Val) {
            return Val;
        }
        return 0;
    }

    lastSearchObject: any;
    ledgerRef: any;
    custLedgercolumnDefs: any;
    custLedgerRowData: any;
    ledgerSearch: any = {};
    ledgerrowData_DocType: any;
    showshippingrow: any = 0;
    checkWith_ShipTo: any = 0;
    customerLedgermain() {
        if (isNaN(Date.parse(this.ledgerSearch.From_Date))) {
            this.toastWarningMsg("Invalid From Date!");
            $("#From_Date").focus();
            return false;
        }
        if (isNaN(Date.parse(this.ledgerSearch.To_Date))) {
            this.toastWarningMsg("Invalid To Date!");
            $("#To_Date").focus();
            return false;
        }
        if (Date.parse(this.ledgerSearch.To_Date) < Date.parse(this.ledgerSearch.From_Date)) {
            this.toastWarningMsg("From date can not be greater than to date!");
            return false;
        }

        this.custLedgerRowData = [];
        this.custLedgercolumnDefs = [];
        let To_Date = moment(this.ledgerSearch.To_Date).format('YYYY-MM-DD');
        let From_Date = moment(this.ledgerSearch.From_Date).format('YYYY-MM-DD');
        let AllUnit = this.f_chkNum(this.ledgerSearch.Unit_ID) == 0 ? 1 : 0;
        var data = {
            "Customer_ID": this.Customer_ID,
            "Unit_ID": this.f_chkNum(this.ledgerSearch.Unit_ID),
            "Company_ID": this.unitInfo.Company_ID,
            "From_Date": From_Date,
            "To_Date": To_Date,
            "DocType_Desc": this.ledgerSearch.Transaction_Type ? this.ledgerSearch.Transaction_Type.flat().join(",") : 0,
            "With_PDC": this.f_chkNum(this.ledgerSearch.With_PDC),
            "AllUnit": AllUnit
        };
        this.busy = this.http.post('/api/customers/Get_Ledger_Customer_Wise', data)
            .subscribe(response => {
                var res = [];
                res.push(response);
                let self = this;
                this.custLedgerRowData = res[0].ledgerData;

                //var self = this;
                this.custLedgercolumnDefs = [
                    { headerName: 'Unit Name', field: 'Unit_Name', width: 150 },
                    { headerName: 'Doc Type', field: 'DocType_Desc', width: 150 },
                    { headerName: 'Doc No', field: 'TransNo', width: 150 },
                    {
                        headerName: 'Doc Date', field: 'Doc_Date', width: 100, cellRenderer: (data) => {
                            if (data.value) {
                                return moment(data.value).format(self.dateFormat.dateInputFormat);
                            }
                            else {
                                return data.value ? data.value == "Total :" ? data.value : moment(data.value).format(this.dateFormat.dateInputFormat) : "";
                                // return '-';
                            }
                        }
                    },
                    {
                        headerName: 'Due Date', field: 'Due_Date', width: 100, cellRenderer: (data) => {
                            if (data.value) {
                                return moment(data.value).format(self.dateFormat.dateInputFormat);
                            }
                            else {
                                return data.value ? data.value == "Total :" ? data.value : moment(data.value).format(this.dateFormat.dateInputFormat) : "";
                                
                            }
                        }
                    },
                    { headerName: 'Remarks', field: 'Remarks', width: 400,
                        autoHeight: true,
                        cellRenderer: (params) => {

                            let remarks = params.value || '';
                            let shippingHtml = '';

                            if (
                            this.showshippingrow !== 1 && (this.f_chkNum(this.With_ShipTo) == 1) && 
                            params.data.ShippingInfoText 
                            ) {
                            shippingHtml = `
                                <div style="
                                margin-top:6px;
                                padding:6px 8px;
                                color:#b455b6;
                                font-weight:600;
                                font-size:12px;
                                border-left:3px solid #b455b6;
                                background:#faf5fb;
                                ">
                                ${params.data.ShippingInfoText.replace('\n', '<br>')}
                                
                                </div>`;
                            }
                            return `
                            <div style="white-space:normal; line-height:16px;">
                                ${remarks}
                                ${shippingHtml}
                            </div>
                            `;
                        } },
                    { headerName: 'Debit', field: 'Debit', width: 100, cellStyle: { textAlign: 'right' } },
                    { headerName: 'Credit', field: 'Credit', width: 100, cellStyle: { textAlign: 'right' } },
                    { headerName: 'Balance', field: 'Balance', width: 100, cellStyle: { textAlign: 'right' } },
                    { headerName: '', field: 'DRCR', width: 50 },
                    { headerName: 'Reco Date', field: 'RecoDate', width: 100, cellStyle: { color: 'red' } },
                    { headerName: 'ShippingInfoText', field: 'ShippingInfoText', width: 100, hide: true, getQuickFilterText: (params) => {
                        return params.value || '';
                    } }
                // ,{ headerName: 'Ship_Cust_Code', field: 'Ship_Cust_Code', width: 110, cellStyle: { textAlign: 'right' } , hide: true}
                //     ,{ headerName: 'Ship_Cust_Name', field: 'Ship_Cust_Name', width: 250, cellStyle: { textAlign: 'right' } , hide: true}
                //     ,{ headerName: 'Ship_Area', field: 'Ship_Area', width: 100, cellStyle: { textAlign: 'right' } , hide: true}
                //     ,{ headerName: 'Ship_City', field: 'Ship_City', width: 100, cellStyle: { textAlign: 'right' } , hide: true}
                //     ,{ headerName: 'Ship_State', field: 'Ship_State', width: 100, cellStyle: { textAlign: 'right' } , hide: true}
                 ];
                this.rowClassRules = {
                    "cheque-return": function (params) {
                        var Chq_return = params.data.Cncl_Ind;
                        var Cheque_Return_Status = self.f_chkNum(params.data.Cheque_Return_Status);
                        return Chq_return == 1 || Cheque_Return_Status > 0;
                    },

                    "cheque-cancel": function (params) {
                        var Chq_return = params.data.Cncl_Ind;
                        var Cheque_Return_Status = self.f_chkNum(params.data.Cheque_Return_Status);
                        return Chq_return == 2;
                    },

                    "fullyadjusted": function (params) {
                        var fully_adjusted = params.data.Adj_Flag;
                        var Chq_return = params.data.Cncl_Ind;
                        return fully_adjusted == "F" && !(Chq_return == 1 || Chq_return == 2);
                    },

                    "partiallyAdjusted": function (params) {
                        var partially_adjusted = params.data.Adj_Flag;
                        var Chq_return = params.data.Cncl_Ind;
                        return partially_adjusted == "P" && !(Chq_return == 1 || Chq_return == 2);
                    }
                };
                var ledgerDetails = res[0].ledgerFooterData[0];
                if (this.lastSearchObject.From_Date != this.ledgerSearch.From_Date || this.lastSearchObject.To_Date != this.ledgerSearch.To_Date) {
                    this.ledgerrowData_DocType = this.findUnique(res[0].ledgerData, d => d.DocType_Desc)
                }
                this.lastSearchObject.From_Date = this.ledgerSearch.From_Date;
                this.lastSearchObject.To_Date = this.ledgerSearch.To_Date;

                var OP = this.f_chkNum(ledgerDetails.Opening_Balance);
                var CB = this.f_chkNum(ledgerDetails.Closing_Balance);
                var TopRow = {}, BottomRow = {};
                if (OP <= 0) {
                    TopRow = { "Remarks": "Opening Balance", "Debit": (OP < 0 ? OP * -1 : OP).toFixed(2), "Credit": '' };
                } else {
                    TopRow = { "Remarks": "Opening Balance", "Debit": '', "Credit": OP.toFixed(2) };
                }
                if (CB <= 0) {
                    BottomRow = { "Remarks": "Closing Balance", "Debit": (CB < 0 ? CB * -1 : CB).toFixed(2), "Credit": '' };
                } else {
                    BottomRow = { "Remarks": "Closing Balance", "Debit": '', "Credit": CB.toFixed(2) };
                }
                // var TotalCustLedgerRowData = {"TransNo":"Total Count : "+this.custLedgerRowData.length,"Remarks":"Total :", "Debit": 0, "Credit" : 0};
                // TotalCustLedgerRowData.Debit = (this.custLedgerRowDataFooter.reduce(function(acc,sum){
                //     return acc + parseFloat(sum.Debit)},0));
                // TotalCustLedgerRowData.Credit = (this.custLedgerRowDataFooter.reduce(function(acc,sum){
                //     return acc + parseFloat(sum.Credit)},0)); 
                var BottomTotal = { "DocType_Desc": "Total Count : ", "TransNo": this.custLedgerRowData.length, "Bill_No": "Total :", "Debit": this.f_chkNum(ledgerDetails.Debit).toFixed(2), "Credit": this.f_chkNum(ledgerDetails.Credit).toFixed(2) };
                setTimeout(() => {
                    this.gridApicustLedger.setPinnedTopRowData([TopRow]);
                    this.gridApicustLedger.setPinnedBottomRowData([BottomRow, BottomTotal]);
                }, 300);
                setTimeout(() => {
                    if (this.gridApicustLedger.getModel().getRowCount() > 0) {
                        this.gridApicustLedger.getModel().getRow(0).setSelected(true);
                    }
                    // this.gridApicustLedger.sizeColumnsToFit();
                    this.gridApicustLedger.setColumnDefs(this.custLedgercolumnDefs);
                    this.gridApicustLedger.setRowData(this.custLedgerRowData);

                    // ⭐ THIS LINE IS THE MISSING PIECE
                    // this.gridApicustLedger.refreshClientSideRowModel('everything');

                    this.gridApicustLedger.resetRowHeights();
                    this.gridApicustLedger.sizeColumnsToFit();

                    this.gridApicustLedger.refreshCells({force: true});
                }, 300);
            });
    }

    CustomerLedgerNavigateScreen(event) {
        let parent = this;
        if (event.keyCode == 13 || event.type == "rowDoubleClicked") {
            let focusedCell = this.gridApicustLedger.getFocusedCell();
            if (focusedCell && focusedCell.column["colDef"]["field"] == "TransNo") {
                let selectedRows = this.gridApicustLedger.getSelectedRows();
                let TransNo = this.f_chkNum(selectedRows[0].Transaction_No);
                let TransType = this.f_chkNum(selectedRows[0].Transaction_Type);
                let Doc_Date = selectedRows[0].Doc_Date;
                if (TransNo > 0) {
                    let data_navi = { "ScreenType": TransType, "Transaction_No": TransNo, "Transaction_Date": Doc_Date }
                    parent.commonFunction.Nevigate_Document_Entry(data_navi);
                }
            }
        }
    }

    gridApicustLedger: GridApi;
    gridColumnApicustLedger: any;
    custLedgerGridReady(params) {
        this.gridApicustLedger = params.api;
        this.gridColumnApicustLedger = params.columnApi;
        this.gridApicustLedger.sizeColumnsToFit();
        this.toggleShipToColumns();
    }

    ledgerRowSelected: any =[];
    LedgerTransType: any;
    Salesman_Bill: any;
    CreatedBy: any;
    CreatedOn: any;
    ledgeronSelectionChanged() {
        this.Salesman_Bill = '';
        var selectedRows = this.gridApicustLedger.getSelectedRows();
        this.ledgerRowSelected = selectedRows[0];
        console.table("wdfwfewfwfw",selectedRows[0]);
        this.LedgerTransType = "";
        if (selectedRows.length > 0) {
            this.LedgerTransType = this.f_chkNum(selectedRows[0].Transaction_Type);
            this.Salesman_Bill = selectedRows[0].Salesman;
            this.CreatedBy = selectedRows[0].CreatedBy;
            this.CreatedOn = selectedRows[0].CreatedOn;
        }

    }

    oneMonthAgo() {
        var monthAgo = new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 1,
            new Date().getDate()
        );
        return monthAgo;
    }

    findUnique(arr, predicate) {
        var found = {};
        arr.forEach(d => {
            found[predicate(d)] = d;
        });
        return Object.keys(found).map(key => found[key]);
    }

    exportExcelLedger(id: any = 1) {
        let self = this;
        let To_Date = moment(this.ledgerSearch.To_Date).format('DD-MMM-YYYY');
        let From_Date = moment(this.ledgerSearch.From_Date).format('DD-MMM-YYYY');
        let row = 'Customer Name : ' + this.Customer_Name + '\n' + 'From : ' + From_Date + ',' + 'To : ' + To_Date
        let d = new Date();
        var fName = 'Ledger_' + d.getTime();
        var params = {
            columnGroups: true,
            skipFooters: false,
            allColumns: false,
            fileName: fName,
            processCellCallback: (cellParams) => {
                // ONLY for Remarks column
                if (cellParams.node.data.ShippingInfoText && self.isShipToEnabled()) {
                    if (cellParams.column.getColId() === 'Remarks' && self.isShipToEnabled() && cellParams.node.data.ShippingInfoText) {
                        console.log("========Adj 2======>", (cellParams.value || '') + '\nShip To Info: ' + cellParams.node.data.ShippingInfoText);
                        if(self.f_chkString(cellParams.value)){
                            return (
                                (cellParams.value || '') +
                                ' | ' +
                                cellParams.node.data.ShippingInfoText.replace('<br />', ' : ')
                            );
                        }else{
                            return (
                                cellParams.node.data.ShippingInfoText.replace('<br />', ' : ')
                            );
                        }
                    }
                    // console.log("========4======>", cellParams.value);
                    return cellParams.value;
                }else{
                    return cellParams.value;
                } 
            }
        };

        if(id == 2){
            this.gridApicustLedger_adj.exportDataAsCsv(params);
            return;
        }
        this.gridApicustLedger.exportDataAsCsv(params);
    }

    printLedger() {
        var data = {
            "FileName": "rptcustomerledger"
            , "FormatType": "pdf"
            , "params": {
                FromDate: moment(this.ledgerSearch.From_Date).format('YYYY-MM-DD'),
                ToDate: moment(this.ledgerSearch.To_Date).format('YYYY-MM-DD'),
                Customer: this.Customer_ID,
                DocType_Desc: this.ledgerSearch.Transaction_Type ? this.ledgerSearch.Transaction_Type.flat().join(",") : 0,
                With_PDC: this.f_chkNum(this.ledgerSearch.With_PDC)
            }
        };

        this.busy = this.commonReportService.GetJasperReportTransaction(data).subscribe(response => {
            var filename = '';
            if (response) {
                var error = '';
                error = response["error"];
                filename = response["FilePath"];
                if (filename.length > 0) {
                    window.open(filename, '_blank');
                }
            }
        });
        this.PrintOptionModalReference.close();
    }

    printLedgerAdjustment() {
        var data = {
            "FileName": "rptcustomerledger_Adjustmentwise"
            , "FormatType": "pdf"
            , "params": {
                FromDate: moment(this.ledgerSearch.From_Date).format('YYYY-MM-DD'),
                ToDate: moment(this.ledgerSearch.To_Date).format('YYYY-MM-DD'),
                Customer: this.Customer_ID,
                DocType_Desc: this.ledgerSearch.Transaction_Type ? this.ledgerSearch.Transaction_Type.flat().join(",") : 0,
                With_PDC: this.f_chkNum(this.ledgerSearch.With_PDC)
            }
        };

        this.busy = this.commonReportService.GetJasperReportTransaction(data).subscribe(response => {
            var filename = '';
            if (response) {
                var error = '';
                error = response["error"];
                filename = response["FilePath"];
                if (filename.length > 0) {
                    window.open(filename, '_blank');
                }
            }
        });
        this.PrintOptionModalReference.close();
    }

    email_flag: number = 1;
    status: string = "";
    async emailLedger() {
        try {
            this.email_flag = 0;
            this.status = "Generating ledger..";
            var data = {
                "FileName": "rptcustomerledger"
                , "FormatType": "pdf"
                , "params": {
                    FromDate: moment(this.ledgerSearch.From_Date).format('YYYY-MM-DD'),
                    ToDate: moment(this.ledgerSearch.To_Date).format('YYYY-MM-DD'),
                    Customer: this.Customer_ID,
                    DocType_Desc: this.ledgerSearch.Transaction_Type ? this.ledgerSearch.Transaction_Type.flat().join(",") : 0,
                    With_PDC: this.f_chkNum(this.ledgerSearch.With_PDC)
                }
            };

            let pdf_filename_path = "";
            let promise = new Promise((resolve, reject) => {
                this.busy = this.commonReportService.GetJasperReportTransaction(data).subscribe(pdf_response => {
                    if (pdf_response) {
                        var error = '';
                        error = pdf_response["error"];
                        pdf_filename_path = pdf_response["FilePath"];
                        if (typeof (pdf_filename_path) != "undefined" && pdf_filename_path.length > 0 && error == "") {
                            resolve(pdf_filename_path);
                        } else {
                            reject("");
                        }

                    } else {
                        reject("");
                    }
                });
            });

            let payload = {
                pdf_filename_path: "",
                UnitId: this.unitInfo.Unit_ID,
                CompanyId: this.unitInfo.Company_ID,
                cust_id: this.Customer_ID
            }
            let pdffile = await Promise.all([promise]);

            if (typeof (pdffile) != "undefined" && pdffile.length > 0) {

                payload.pdf_filename_path = pdffile[0].toString();
                this.status = "Sending mail..";
                this.busy = this.http.post('/api/customers/SendEmailLedger', payload).subscribe((data) => {
                    if (typeof (data) != "undefined" && typeof (data["error_code"]) != "undefined" && data["error_code"] == 0) {
                        this.toastWarningMsg(`Mail Successfully sent!`);
                    } else {
                        this.toastWarningMsg(`Failed to sent mail. Please try again!`);
                    }
                    this.email_flag = 1;
                    this.status = "";
                });

            } else {
                this.email_flag = 1;
                this.status = "";
                this.toastWarningMsg(`Failed to generate ledger. Please try again!`);
            }
        } catch (ex) {
            this.status = "";
            this.email_flag = 1;
        }

    }

    onPopupFilterTextBoxChanged(e) {
        let value = $('input#cust-ledger-filter-text-box').val();
        this.gridApicustLedger.setQuickFilter(value);
    }

    CustHandleKeyDown(event) {
        if (event.which == 13) {
            this.gridApicustLedger.setFocusedCell(0, "TransNo");
        }
    }

    OpenPayReceiptPopup() {
        setTimeout(() => {
            this.modalService.open(this.payreciptpopup, { size: 'sm', windowClass: 'data-show ledger' });
        }, 200);
    }

    

    OnBtnClick(type,OptionModal){
        this.type = type;

        this.optionmodalReference = this.modalService.open(OptionModal, { size: 'lg', windowClass: 'data-show SmallSizePopup' });
        setTimeout(() => {
            $('#WTA_button').focus();
        }, 500);
    };

    OnPrintBtnClick(type, PrintOptionModal){
        this.type = type;
        this.PrintOptionModalReference = this.modalService.open(PrintOptionModal, { size: 'lg', windowClass: 'data-show SmallSizePopup' });
        setTimeout(() => {
            $('#Print_button').focus();
        }, 500);
    }
    
    OnModalBtnClick(type, Adj){  // Adj - 1: Without Adjustment , 2: with Adjustment
        if(type === "Export"){
            if (Adj == 1){
                this.exportExcelLedger(1);
            }else{
                this.customerLedgermain_adj(2);
            }
        }
        this.optionmodalReference.close();
    }



    custLedgercolumnDefs_adj: any;
    custLedgerRowData_adj: any;
    ledgerrowData_DocType_adj: any;
    customerLedgermain_adj(id: any = 2) {
        this.custLedgerRowData_adj = [];
        let To_Date = moment(this.ledgerSearch.To_Date).format('YYYY-MM-DD');
        let From_Date = moment(this.ledgerSearch.From_Date).format('YYYY-MM-DD');
        let AllUnit = this.f_chkNum(this.ledgerSearch.Unit_ID) == 0 ? 1 : 0;
        var data = {
            "Customer_ID": this.Customer_ID,
            "Unit_ID": this.f_chkNum(this.ledgerSearch.Unit_ID),
            "Company_ID": this.unitInfo.Company_ID,
            "From_Date": From_Date,
            "To_Date": To_Date,
            "DocType_Desc": this.f_chkNum(this.ledgerSearch.Transaction_Type),
            "With_PDC": this.f_chkNum(this.ledgerSearch.With_PDC),
            "AllUnit": AllUnit
        };
        this.busy = this.http.post('/api/customers/Get_Ledger_Customer_Wise_Adj', data)
        .subscribe(response => {
            var res = [];
            res.push(response);
            let self = this;
            this.custLedgerRowData_adj = res[0].ledgerData;

            //var self = this;
            this.custLedgercolumnDefs_adj = [
                {  headerName: 'Unit Name', field: 'Unit_Name', width: 150 },
                { headerName: 'Doc Type', field: 'DocType_Desc', width: 150 },
                { headerName: 'Doc No', field: 'TransNo', width: 150 },
                {
                    headerName: 'Date', field: 'Doc_Date', width: 100, cellRenderer: (data) => {
                        if (data.value) {
                            return moment(data.value).format(self.dateFormat.dateInputFormat);
                        }
                        else {
                            return data.value ? data.value == "Total :" ? data.value : moment(data.value).format(this.dateFormat.dateInputFormat) : "";
                            // return '-';
                        }
                    }
                },
                { headerName: 'Remarks', field: 'Remarks', width: 400,
                autoHeight: true,
                cellRenderer: (params) => {

                    let remarks = params.value || '';
                    let shippingHtml = '';

                    if (
                    this.showshippingrow !== 1 && this.f_chkNum(this.With_ShipTo) == 1 && 
                    params.data.ShippingInfoText 
                    ) {
                    shippingHtml = `
                        <div style="
                        margin-top:6px;
                        padding:6px 8px;
                        color:#b455b6;
                        font-weight:600;
                        font-size:12px;
                        border-left:3px solid #b455b6;
                        background:#faf5fb;
                        ">
                        ${params.data.ShippingInfoText.replace('\n', '<br>')}
                        
                        </div>`;
                    }
                    return `
                    <div style="white-space:normal; line-height:16px;">
                        ${remarks}
                        ${shippingHtml}
                    </div>
                    `;
                } },
                { headerName: 'Debit', field: 'Debit', width: 100, cellStyle: { textAlign: 'right' } },
                { headerName: 'Credit', field: 'Credit', width: 100, cellStyle: { textAlign: 'right' } },
                { headerName: 'Balance', field: 'Balance', width: 100, cellStyle: { textAlign: 'right' } },
                { headerName: '', field: 'DRCR', width: 50 },
                { headerName: 'Reco Date', field: 'RecoDate', width: 100, cellStyle: { color: 'red' } },
                { headerName: 'Adjustment Details', field: 'Adjdetail', width: 200},
                { headerName: 'ShippingInfoText', field: 'ShippingInfoText', width: 100, hide: true, getQuickFilterText: (params) => {
                    return params.value || '';
                } }
            ];
            this.rowClassRules1 = {
                "cheque-return": function (params) {
                    var Chq_return = params.data.Cncl_Ind;
                    var Cheque_Return_Status = self.f_chkNum(params.data.Cheque_Return_Status);
                    return Chq_return == 1 || Cheque_Return_Status > 0;
                }
            };
            var ledgerDetails = res[0].ledgerFooterData[0];
            if (this.lastSearchObject.From_Date != this.ledgerSearch.From_Date || this.lastSearchObject.To_Date != this.lastSearchObject.To_Date) {
                this.ledgerrowData_DocType_adj = this.findUnique(res[0].ledgerData, d => d.DocType_Desc)
            }
            this.lastSearchObject.From_Date = this.ledgerSearch.From_Date;
            this.lastSearchObject.To_Date = this.ledgerSearch.To_Date;

            var OP = this.f_chkNum(ledgerDetails.Opening_Balance);
            var CB = this.f_chkNum(ledgerDetails.Closing_Balance);
            var TopRow = {}, BottomRow = {};
            if (OP <= 0) {
                TopRow = { "Remarks": "Opening Balance", "Debit": (OP < 0 ? OP * -1 : OP).toFixed(2), "Credit": '' };
            } else {
                TopRow = { "Remarks": "Opening Balance", "Debit": '', "Credit": OP.toFixed(2) };
            }
            if (CB <= 0) {
                BottomRow = { "Remarks": "Closing Balance", "Debit": (CB < 0 ? CB * -1 : CB).toFixed(2), "Credit": '' };
            } else {
                BottomRow = { "Remarks": "Closing Balance", "Debit": '', "Credit": CB.toFixed(2) };
            }

            var BottomTotal = { "DocType_Desc": "Total Count : ", "TransNo": this.custLedgerRowData_adj.length, "Bill_No": "Total :", "Debit": this.f_chkNum(ledgerDetails.Debit).toFixed(2), "Credit": this.f_chkNum(ledgerDetails.Credit).toFixed(2) };
            setTimeout(() => {
                this.gridApicustLedger_adj.setPinnedTopRowData([TopRow]);
                this.gridApicustLedger_adj.setPinnedBottomRowData([BottomRow, BottomTotal]);
            }, 300);
            setTimeout(() => {
                if (this.gridApicustLedger_adj.getModel().getRowCount() > 0) {
                    this.gridApicustLedger_adj.getModel().getRow(0).setSelected(true);
                }
                this.gridApicustLedger_adj.sizeColumnsToFit();
                this.exportExcelLedger(2);
            }, 300);
        });
    }

    gridApicustLedger_adj: any;
    gridColumnApicustLedger_adj: any;
    custLedgerGridReady_adj(params) {
        this.gridApicustLedger_adj = params.api;
        this.gridColumnApicustLedger_adj = params.columnApi;
        this.gridApicustLedger_adj.sizeColumnsToFit();
        this.toggleShipToColumns();
    }

    OpenAccountPostingtPopup() {
        setTimeout(() => {
            this.modalService.open(this.accountpostingpopup, { size: 'lg', windowClass: 'data-show width75 accountposting updateWarehouseWidth', backdropClass: 'productPop' });
        }, 200);
    };

    ExportExcel() {
        let self = this;
        let d = new Date();
        var fName = 'Cus_Ledger' + d.getTime();
        var params: CsvExportParams = {
            columnGroups: true,
            skipFooters: false,
            allColumns: false,
            fileName: fName,
            processCellCallback: (cellParams) => {
                if ( cellParams.node.data.ShippingInfoText && self.isShipToEnabled()) {
                    if (cellParams.column.getColId() === 'Remarks' && self.isShipToEnabled() && cellParams.node.data.ShippingInfoText) {
                        if(self.f_chkString(cellParams.value)){
                            return (
                                (cellParams.value || '') +
                                ' | ' +
                                cellParams.node.data.ShippingInfoText.replace('<br />', ' : ')
                            );
                        }else{
                            return (
                                cellParams.node.data.ShippingInfoText.replace('<br />', ' : ')
                            );
                        }
                    }
                    return cellParams.value;
                }else{
                    return cellParams.value;
                }
            }
        };
        this.gridApicustLedger.exportDataAsCsv(params);
    }

    toggleShipToColumns() {
        // Rebuild columnDefs with updated hide property
        if(this.custLedgercolumnDefs) {
            this.custLedgercolumnDefs = this.custLedgercolumnDefs.map(col => {
                return col;
            });
        }
        setTimeout(() => {
            if (this.gridApicustLedger) {
                this.gridApicustLedger.resetRowHeights();   // recalc row height
                this.gridApicustLedger.sizeColumnsToFit();  // recalc column width
                this.gridApicustLedger.refreshCells({ force: true });
            } 
        }, 300);
    }

    toggleShipToColumns_adj() {
        // Rebuild columnDefs with updated hide property
        this.custLedgercolumnDefs_adj = this.custLedgercolumnDefs_adj.map(col => {
            return col;
        });

        setTimeout(() => {
            if (this.gridApicustLedger_adj) {
                this.gridApicustLedger_adj.resetRowHeights();   // recalc row height
                this.gridApicustLedger_adj.sizeColumnsToFit();  // recalc column width
                this.gridApicustLedger_adj.refreshCells({ force: true });
            } 
        }, 300);
    }

    getRowHeight = (params) => {
        if (
            this.showshippingrow !== 1 &&
			params.data.ShippingInfoText && this.f_chkNum(this.With_ShipTo) == 1
        ) {
            return 100;
        }
        return 35;
    };

    isShipToEnabled(): boolean {
        return this.f_chkNum(this.With_ShipTo) === 1;
    }

    async getUserUnitList(): Promise<any[]> {
        return new Promise<any[]>((resolve, reject) => {
            let payload = {
                user_ID: this.unitInfo._id,
            };
            this.busy = this.http.post('/api/users/getUnitData', payload)
                .subscribe((response: any) => {
                    // if (response && response.UnitList) {
                    //     resolve(response.UnitList || []);
                    // } else {
                    //     resolve([]);
                    // }
                    if (response && response.UnitList) {
                        resolve(response.UnitList || []);

                        // if(this.unitInfo.IS_HO == 0){
                            this.ledgerSearch.Unit_ID = this.unitInfo.Unit_ID;
                        // }

                        this.customerLedgermain();
                    } else {
                        resolve([]);
                    }
                })
        })
    }
}

